import { defineStyle, defineStyleConfig } from '@chakra-ui/react';
import { focusColor } from './colors.config';

const subtle = defineStyle({
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: 'blackAlpha.200',
});

const oz = defineStyle({
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: 'oz.tertiary',
});

export const Divider = defineStyleConfig({
  variants: { subtle, oz },
});
